import { createAction, props } from '@ngrx/store';

export const loadRetailOrdersDropdownSuccess = createAction(
  '[Retail Orders Component] Load Retail Orders Dropdown Success',
  props<{ retailOrders: any | null }>()
);
export const loadRetailOrdersDropdownData = createAction(
  '[Retail Orders Component] Load Retail Orders Dropdown Data',
  props<{ orderData: any | null }>()
);

export const loadRetailOrdersDropdownFailure = createAction(
  '[Retail Orders Component] Load Retail Orders Dropdown Failure',
  props<{ error: any }>()
);

// API actions
export const loadRetailOrdersDropdownApi = createAction(
  '[Retail Orders API] Load Retail Orders Dropdown'
);
